var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCurrentParent)?_c('StepperProfileSignup'):_c('ProspectQuestions')
}
var staticRenderFns = []

export { render, staticRenderFns }